import styled from 'styled-components';
import { RiLockPasswordLine } from 'react-icons/ri';
import { Col, Row } from 'react-bootstrap';
import { Outlet, useMatch, useResolvedPath } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import SubHeading from '../../../../Components/SubHeading';

function Security() {
  return (
    <div className="card content-section">
      <div className="card-header">
        <SubHeading id="security" Icon={RiLockPasswordLine} />
      </div>
      <div className="card-body">
        <Row className="border">
          <Col md={2} className="border-end">
            <div className="px-1 py-3">
              {[
                {
                  path: 'update-password',
                  title: 'security.update-password'
                },

                {
                  path: 'update-pin',
                  title: 'security.update-pin'
                }
              ].map((item) => {
                let resolved = useResolvedPath(item.path);
                let match = useMatch({ path: resolved.pathname, end: true });
                return (
                  <NavLink key={item.title} to={item.path}>
                    <StyledNav
                      className={`d-flex px-2 py-3 border-bottom ${match ? 'active' : ''}`}>
                      {<FormattedMessage id={item.title} />}
                    </StyledNav>
                  </NavLink>
                );
              })}
            </div>
          </Col>
          <Col md={10}>
            <div className="px-1 py-3">
              <Outlet />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Security;

const StyledNav = styled.div`
  &.active {
    background: #4772be9e;
    color: #ffffff;
    border-radius: 5px;
  }
`;
